import localUtils from '@common/helpers/localStorage.utils';
import { getCurrentRoute } from '@common/router/router';
import notification from '@common/components/notification/notification.component';
import { EnumNotificationPlacement } from '@common/components/notification/enums/notificationPlacement.enum';

export default {
  setAlertaUrl(url){
    localUtils.setItem('ALERTA_URL', url);
  },
  getAlertaUrl(){
    return localUtils.getItem('ALERTA_URL') ?? '';
  },
  setAlertasRotas(data){
    localUtils.setItem('ALERTAS_ROTAS', data);
  },
  getAlertasRotas(){
    return localUtils.getItem('ALERTAS_ROTAS') ?? [];
  },
  setOrigem(data){
    const origem = localUtils.getItem('ALERTAS_ORIGEM');

    if(origem)
      localUtils.setItem('ALERTAS_ORIGEM', {...origem, ...data});
    else
      localUtils.setItem('ALERTAS_ORIGEM', data);
  },
  getOrigem(){
    return localUtils.getItem('ALERTAS_ORIGEM');
  },
  removeOrigem(){
    localUtils.removeItem('ALERTAS_ORIGEM');
  },
  resetAlertas(){
    localUtils.removeItem('ALERTA_URL');
    localUtils.removeItem('ALERTAS_ORIGEM');
  },
  getCurrentRouteUrl() {
    const currentRoute = getCurrentRoute();

    if (window.location.hash.endsWith('tributario/') || window.location.hash.endsWith('#/')) return '/';
    else return currentRoute?.path;
  },
  checkAlertas() {
    const origem = this.getOrigem();
    const currentRouteUrl = this.getCurrentRouteUrl();

    if ((currentRouteUrl != this.getAlertaUrl()) || origem?.ShowAlertaOrigem) {
      const alertaUrl = currentRouteUrl;
      const rotas = this.getAlertasRotas();

      this.setAlertaUrl(alertaUrl);

      if (rotas.length > 0) {
        const alertas = rotas.filter((r) => r.Urls.filter((u) => u == alertaUrl)?.length > 0);

        if (origem?.ShowAlertaOrigem || alertas) {
          alertas?.forEach((alerta) => {
            const hasOrigem = alerta.IdOrigem
              ? alerta.IdOrigem == origem?.IdOrigem && alerta.SetorOrigem == origem?.SetorOrigem
              : alerta.SetorOrigem == origem?.SetorOrigem && alerta.SetorOrigem != '';

            if ((hasOrigem || alerta.SetorOrigem == '') && origem?.IsPesquisaDebito && alerta.AlertaDebito) {
              notification.showWarning({
                description: alerta.Alerta,
                placement: EnumNotificationPlacement.BottomRight,
              });
            } else if (
              alertas &&
              !alerta.AlertaDebito &&
              (origem
                ? !origem?.IsPesquisaDebito && hasOrigem
                : !alerta.IdOrigem && alerta.SetorOrigem == '' && !alerta.AlertaDebito)
            ) {
              notification.showWarning({
                description: alerta.Alerta,
                placement: EnumNotificationPlacement.BottomRight,
              });
            }

            this.removeOrigem();
          });
        }
      }
    }
  }
}
